<template>
  <div class="directory-letter-toggle">
    <button
      type="button"
      :key="letter.char"
      v-for="letter in letters"
      :disabled="!letter.enabled"
      v-text="letter.char"
      @click="$parent.setLetterView(letter.char)"
      :class="{ 'is-active': letter.char === letterView }"
    />
  </div>
</template>

<script>
export default {
  name: 'DirectoryLetterToggle',

  props: {
    letterView: {
      type: String
    },

    letters: {
      type: Array,
      default: []
    }
  }
}
</script>
